/**
 * Centralized client-side error logging.
 * Extend this to send errors to Sentry or another service in production.
 * @param {string} context - Where the error occurred
 * @param {unknown} error
 * @param {unknown} [extra]
 */
export function logError(context, error, extra) {
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${context}]`, error, extra || '');
    return;
  }

  // Production: log without sensitive details; wire to Sentry when REACT_APP_SENTRY_DSN is set
  console.error(`[${context}]`, error instanceof Error ? error.message : error);
}

/**
 * Report web vitals to console (or analytics when configured).
 * @param {Function} onPerfEntry
 */
export function reportWebVitals(onPerfEntry) {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
}
